import {
  Attribute,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';

import { environment } from '@environment';

@JsonApiModelConfig({
  baseUrl: `${environment.backendBaseUrl}/api/v1`,
  type: 'self_registrations',
})
export class SelfRegistration extends JsonApiModel {
  @Attribute()
  enabled!: boolean;

  @Attribute()
  link!: string;

  @Attribute()
  passcode!: string;

  @Attribute({ serializedName: 'member_attributes' })
  memberAttributes!: Record<string, string>;

  @Attribute({ serializedName: 'login_type' })
  loginType!: string; // 'email' | 'username' | 'both'

  @Attribute({ serializedName: 'created_at' })
  createdAt!: Date;

  @Attribute({ serializedName: 'updated_at' })
  updatedAt!: Date;
}
